import { MaintenanceWindowRebootOptionsWebComponent } from './component/MaintenanceWindowRebootOptionsWebComponent';
import { WEB_COMPONENT_MAINTENANCE_WINDOW_REBOOT_OPTIONS } from '../../webcomponents.constants';

export { MaintenanceWindowRebootOptionsWebComponent };

window.customElements.define(
  WEB_COMPONENT_MAINTENANCE_WINDOW_REBOOT_OPTIONS,
  MaintenanceWindowRebootOptionsWebComponent
);
